import script from "./batchOrderStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./batchOrderStatus.vue?vue&type=script&setup=true&lang=js"

import "./batchOrderStatus.vue?vue&type=style&index=0&id=edb3063e&scoped=true&lang=css"

import exportComponent from "/Users/lock/vuework/yaojing-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-edb3063e"]])

export default __exports__